import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import { createSettingsParams, type ISettingsParam, SettingsParamType } from '@wix/tpa-settings';

export type ISettingsParams = {
  membersAreaTitle: SettingsParamType.Text;
  membersAreaDescription: SettingsParamType.Text;
  membersAreaUpcomingText: SettingsParamType.Text;
  membersAreaHistoryText: SettingsParamType.Text;
  membersAreaUpcomingEmptyText: SettingsParamType.Text;
  membersAreaUpcomingEmptyLink: SettingsParamType.Text;
  membersAreaHistoryEmptyText: SettingsParamType.Text;
  membersAreaHistoryEmptyLink: SettingsParamType.Text;
};

const textSettingsParam = (defaultValueKey: string): Omit<ISettingsParam<SettingsParamType.Text>, 'key'> => ({
  type: SettingsParamType.Text,
  getDefaultValue: ({ t }) => t(defaultValueKey),
  metadata: ({ t }) => ({
    type: DataType.text,
    defaultValue: {
      type: 'static',
      value: t(defaultValueKey),
    },
  }),
});

export default createSettingsParams<ISettingsParams>({
  membersAreaTitle: textSettingsParam('app.my-bookings-widget.header.title'),
  membersAreaDescription: textSettingsParam('app.my-bookings-widget.header.subtitle'),
  membersAreaUpcomingText: textSettingsParam('app.my-bookings-widget.upcoming-tab.label'),
  membersAreaHistoryText: textSettingsParam('app.my-bookings-widget.history-tab.label'),
  membersAreaUpcomingEmptyText: textSettingsParam('app.my-bookings-widget.empty-state.no-upcoming-bookings.label'),
  membersAreaUpcomingEmptyLink: textSettingsParam('app.my-bookings-widget.empty-state.no-upcoming-bookings.button.label'),
  membersAreaHistoryEmptyText: textSettingsParam('app.my-bookings-widget.empty-state.no-history-bookings.label'),
  membersAreaHistoryEmptyLink: textSettingsParam('app.my-bookings-widget.empty-state.no-history-bookings.button.label'),
});
